import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { PrivateService } from 'app/core/services/private.service';
import { ProcessSchedulerService } from 'app/core/services/process-scheduler.service';

@Component({
  selector: 'dialog-process-all',
  templateUrl: './dialog-process-all.component.html',
  styleUrls: ['./dialog-process-all.component.scss']
})
export class DialogProcessAllComponent implements OnInit {

  form: FormGroup;

  payrollTypes: any[] = [];
  filteredPayrollTypes: any[] = [];
  periods: any[] = [];
  filteredPeriods: any[] = [];
  employees: any[] = [];
  filteredEmployees: any[] = [];
  computations: any[] = [];
  filteredSSS: any[] = [];
  filteredPagIbig: any[] = [];
  filteredPhilhealth: any[] = [];

  payrollSearchText = '';
  periodSearchText = '';
  employeeSearchText = '';
  sssSearchText = '';
  pagibigSearchText = '';
  philhealthSearchText = '';

  @ViewChild('payrollSearch') payrollSearch!: ElementRef<HTMLInputElement>;
  @ViewChild('periodSearch') periodSearch!: ElementRef<HTMLInputElement>;
  @ViewChild('employeeSearch') employeeSearch!: ElementRef<HTMLInputElement>;
  @ViewChild('sssSearch') sssSearch!: ElementRef<HTMLInputElement>;
  @ViewChild('pagibigSearch') pagibigSearch!: ElementRef<HTMLInputElement>;
  @ViewChild('philhealthSearch') philhealthSearch!: ElementRef<HTMLInputElement>;

  constructor(
    private dialogRef: MatDialogRef<DialogProcessAllComponent>,
    private fb: FormBuilder,
    private privateService: PrivateService,
    private processSchedulerService: ProcessSchedulerService
  ) {
    this.form = this.fb.group({
      payrollID: ['', Validators.required],
      periodID: ['', Validators.required],
      excludeSeconds: [false],
      bpartnerID: [null],
      docStatus: ['CO'],
      generateInvoice: [false],
      dateInvoiced: [null],
      allocateByBranch: [false],
      sss: ['0'],
      adjustBaseSss: [false],
      pagibig: ['0'],
      philhealth: ['0'],
    });

    this.form.get('generateInvoice')!.valueChanges.subscribe(checked => {
      const ctrl = this.form.get('dateInvoiced')!;
      if (checked) {
        ctrl.setValidators(Validators.required);
      } else {
        ctrl.clearValidators();
        ctrl.setValue(null);
      }
      ctrl.updateValueAndValidity();
    });
  }

  ngOnInit(): void {
    this.loadPayrollTypes();
    this.loadEmployees();
    this.loadComputations();
  }

  loadPayrollTypes(): void {
    this.privateService.getPayrollType().subscribe({
      next: res => { this.payrollTypes = res || []; this.filteredPayrollTypes = [...this.payrollTypes]; },
      error: () => {}
    });
  }

  onPayrollSelected(id: any): void {
    this.periods = [];
    this.filteredPeriods = [];
    this.form.patchValue({ periodID: '' });
    if (!id) return;
    this.privateService.getPeriodOnDepartment(id).subscribe({
      next: res => { this.periods = res || []; this.filteredPeriods = [...this.periods]; },
      error: () => {}
    });
  }

  loadEmployees(): void {
    this.privateService.getEmployeeInfoAll().subscribe({
      next: res => { this.employees = res || []; this.filteredEmployees = [...this.employees]; },
      error: () => {}
    });
  }

  loadComputations(): void {
    this.processSchedulerService.getComputations().subscribe({
      next: res => {
        this.computations = res || [];
        this.filteredSSS = [...this.computations];
        this.filteredPagIbig = [...this.computations];
        this.filteredPhilhealth = [...this.computations];
      },
      error: () => {}
    });
  }

  filterPayrolls(): void {
    const s = this.payrollSearchText.toLowerCase();
    this.filteredPayrollTypes = s ? this.payrollTypes.filter(t => t.payrollType?.toLowerCase().includes(s)) : [...this.payrollTypes];
  }
  filterPeriods(): void {
    const s = this.periodSearchText.toLowerCase();
    this.filteredPeriods = s ? this.periods.filter(p => p.payrollName?.toLowerCase().includes(s)) : [...this.periods];
  }
  filterEmployees(): void {
    const s = this.employeeSearchText.toLowerCase();
    this.filteredEmployees = s ? this.employees.filter(e => e.employeeName?.toLowerCase().includes(s)) : [...this.employees];
  }
  filterSSS(): void {
    const s = this.sssSearchText.toLowerCase();
    this.filteredSSS = s ? this.computations.filter(c => c.name?.toLowerCase().includes(s)) : [...this.computations];
  }
  filterPagIbig(): void {
    const s = this.pagibigSearchText.toLowerCase();
    this.filteredPagIbig = s ? this.computations.filter(c => c.name?.toLowerCase().includes(s)) : [...this.computations];
  }
  filterPhilhealth(): void {
    const s = this.philhealthSearchText.toLowerCase();
    this.filteredPhilhealth = s ? this.computations.filter(c => c.name?.toLowerCase().includes(s)) : [...this.computations];
  }

  onDropdownOpenChange(opened: boolean, type: string): void {
    if (opened) {
      setTimeout(() => {
        const map: Record<string, ElementRef<HTMLInputElement>> = {
          payroll: this.payrollSearch, period: this.periodSearch,
          employee: this.employeeSearch, sss: this.sssSearch,
          pagibig: this.pagibigSearch, philhealth: this.philhealthSearch,
        };
        map[type]?.nativeElement?.focus();
      }, 100);
    } else {
      switch (type) {
        case 'payroll': this.payrollSearchText = ''; this.filterPayrolls(); break;
        case 'period': this.periodSearchText = ''; this.filterPeriods(); break;
        case 'employee': this.employeeSearchText = ''; this.filterEmployees(); break;
        case 'sss': this.sssSearchText = ''; this.filterSSS(); break;
        case 'pagibig': this.pagibigSearchText = ''; this.filterPagIbig(); break;
        case 'philhealth': this.philhealthSearchText = ''; this.filterPhilhealth(); break;
      }
    }
  }

  getPayrollTypeName(id: any): string { return this.payrollTypes.find(t => t.hrpayrollID === id)?.payrollType || ''; }
  getPeriodName(id: any): string { return this.periods.find(p => p.hrperiodID === id)?.payrollName || ''; }
  getEmployeeName(id: any): string { return this.employees.find(e => e.C_BPartner_ID === id)?.employeeName || ''; }
  getSSSName(v: string): string { return this.computations.find(c => c.value === v)?.name || ''; }
  getPagIbigName(v: string): string { return this.computations.find(c => c.value === v)?.name || ''; }
  getPhilhealthName(v: string): string { return this.computations.find(c => c.value === v)?.name || ''; }

  get generateInvoice(): boolean { return this.form.get('generateInvoice')?.value; }

  startProcessAll(): void {
    if (this.form.invalid) return;
    this.dialogRef.close(this.form.value);
  }

  cancel(): void {
    this.dialogRef.close(null);
  }
}
